import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div>      
      <div className="relative float-right h-full min-h-screen w-full !bg-white dark:!bg-intsamis-900 !panel-bg">
        <FixedPlugin />
        <main className="mx-auto min-h-screen">
          <div className="relative flex">
            <div className="mx-auto flex min-h-full w-full flex-col justify-center pt-0 md:max-w-[75%] lg:h-screen lg:max-w-[1013px] lg:px-8 xl:h-[100vh] xl:max-w-[1383px] xl:px-0">
              <div className="mb-auto flex justify-center">
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/auth/sign-in" replace />}
                  />
                </Routes>                
              </div>
            </div>
          </div>
        </main>
      </div>
      {/* <AlertMessage
        message={'Test message display'}
      /> */}
    </div>
  );
}
